import axios from 'axios'
import config from '@/config'

const actions = {
  GET_APARTMENTS({rootGetters}, houseId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'apartment/house/' + houseId, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  GET_APARTMENTS_ALL({rootGetters}, houseId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'apartment/house/' + houseId + '/all', rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  GET_APARTMENT_OCCUPANT({rootGetters}, apartmentId) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          config.APi_URL + 'apartment/occupant-info/' + apartmentId,
          rootGetters.getRequestConfig
        )
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  GET_APARTMENT_CARD({rootGetters}, apartmentId) {
    return new Promise((resolve, reject) => {
      axios
        .get(config.APi_URL + 'apartment-card/' + apartmentId, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  SAVE_APARTMENT_CARD({rootGetters}, community) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'apartment-card/save', community, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  },
  DELETE_APARTMENT_CARD({rootGetters}, apartmentCardId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(
          config.APi_URL + 'apartment-card/delete/' + apartmentCardId,
          rootGetters.getRequestConfig
        )
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  DELETE_APARTMENT({rootGetters}, apartmentId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(config.APi_URL + 'apartment/delete/' + apartmentId, rootGetters.getRequestConfig)
        .then(response => {
          resolve(response)
        })
        .catch(err => reject(err))
    })
  },
  SAVE_APARTMENT({rootGetters}, apartment) {
    return new Promise((resolve, reject) => {
      axios
        .post(config.APi_URL + 'apartment/save', apartment, rootGetters.getRequestConfig)
        .then(response => resolve(response.data))
        .catch(err => reject(err))
    })
  }
}

export default {
  namespaced: true,
  actions
}
